import { HttpErrorResponse } from '@angular/common/http';
import { GetTranslationsDto } from '@modeso/types__aumico-lib-notes-be';
import { EntityState } from '@ngrx/entity';

export interface ITranslationsState extends EntityState<GetTranslationsDto> {
    translations?: GetTranslationsDto;
    error?: HttpErrorResponse;
}
